(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-slider')) {
    class ReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.controls = this.querySelector('[data-controls]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));

        if (!this.track || this.slides.length === 0) return;

        this.handleScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.prevButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        // Theme editor: jump to a review when its block is selected
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target);
          if (index > -1) {
            this.stopAutoplay();
            this.goTo(index, false);
          }
        });
        this.addEventListener('shopify:block:deselect', () => this.startAutoplay());

        // Autoplay (pauses on hover/focus and when reduced motion is preferred)
        this.autoplaySeconds = parseInt(this.dataset.autoplay, 10) || 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.addEventListener('pointerenter', () => this.stopAutoplay());
        this.addEventListener('pointerleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        this.startAutoplay();

        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.stopAutoplay();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      get paddingStart() {
        return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      }

      get maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      get atStart() {
        return this.track.scrollLeft <= 2;
      }

      get atEnd() {
        return this.track.scrollLeft >= this.maxScroll - 2;
      }

      currentIndex() {
        const left = this.track.scrollLeft + this.paddingStart;
        let closest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const d = Math.abs(slide.offsetLeft - left);
          if (d < distance) {
            distance = d;
            closest = index;
          }
        });
        return closest;
      }

      goTo(index, smooth = true) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        const left = this.slides[target].offsetLeft - this.paddingStart;
        this.track.scrollTo({
          left: Math.min(left, this.maxScroll),
          behavior: smooth && !this.reduceMotion ? 'smooth' : 'auto',
        });
      }

      step(direction) {
        if (direction > 0 && this.atEnd) {
          this.goTo(0);
          return;
        }
        this.goTo(this.currentIndex() + direction);
      }

      update() {
        const scrollable = this.maxScroll > 2;
        if (this.controls) this.controls.hidden = !scrollable;

        if (this.prevButton) this.prevButton.disabled = this.atStart;
        if (this.nextButton) this.nextButton.disabled = this.atEnd && !this.autoplaySeconds;

        const active = this.atEnd ? this.slides.length - 1 : this.currentIndex();
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      }

      startAutoplay() {
        if (!this.autoplaySeconds || this.reduceMotion || this.timer) return;
        this.timer = setInterval(() => {
          if (document.hidden) return;
          this.step(1);
        }, this.autoplaySeconds * 1000);
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('review-slider', ReviewSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
